import { CommonModule } from '@angular/common';
import { Component, inject, computed } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

interface DialogData {
  source?: string;
}

@Component({
  selector: 'ai-enable-lead-capture-dialog',
  imports: [CommonModule, MatDialogModule, MatButtonModule, TranslateModule],
  templateUrl: './enable-lead-capture-dialog.component.html',
  styleUrls: ['./enable-lead-capture-dialog.component.scss'],
})
export class EnableLeadCaptureDialogComponent {
  // TODO: We can remove this when we remove the assistant-configuration form v1
  private readonly data = inject<DialogData>(MAT_DIALOG_DATA, { optional: true });

  protected readonly informationKey = computed(() => {
    return this.data?.source === 'capabilities-list'
      ? 'AI_ASSISTANT.SETTINGS.ENABLE_LEAD_CAPTURE_DIALOG.INFORMATION_4'
      : 'AI_ASSISTANT.SETTINGS.ENABLE_LEAD_CAPTURE_DIALOG.INFORMATION_3';
  });
}
